import { M8DebitDTO } from 'services/production/types';
import {
  GiroPaymentManager,
  GiroPaymentManagerData,
} from 'types/giroPaymentManagerTypes';
import {
  createGiroPayment,
  createGiroPaymentMock,
} from 'utils/giroPaymentUtils';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createGiroPaymentManagerData = (): GiroPaymentManagerData => ({
  giroPayment: createGiroPayment(),
  balance: 0,
  m8DebitDTOs: [],
  m8UserLegalRequisites: null,
});

export const createGiroPaymentManager = (): GiroPaymentManager => ({
  giroPaymentId: null,
  screen: 'SUMMARY',
  data: createGiroPaymentManagerData(),
  dataInvalidated: false,
});

export const createGiroPaymentManagerDataMock = (): GiroPaymentManagerData => ({
  giroPayment: createGiroPaymentMock(createUniqueRuntimeNumber()),
  balance: 2422,
  m8DebitDTOs: [
    {
      id: createUniqueRuntimeNumber(),
      user: {
        resident: false,
      },
      amount: 200,
      eurAmount: 333,
      rubAmount: 555,
    } as M8DebitDTO,
  ],
  m8UserLegalRequisites: null,
});
